import {
	Dashboard,
	DateRange,
	LocationCity,
	Payments,
	Pets,
	Receipt,
	Settings
} from '@mui/icons-material'
import {
	red,
	lightBlue,
	lime,
	amber,
	pink,
	deepPurple,
	indigo,
	blue,
	cyan,
	teal,
	green,
	lightGreen,
	yellow,
	deepOrange,
	brown
} from '@mui/material/colors'
import { purple, orange } from '@wolfdanepug/common-react'
import {
	CreditCard,
	EyePasswordShow,
	Invoice,
	Password,
	Send,
	TruckDelivery
} from '@wolfdanepug/icons'
import PetCharacteristics from './components/pet-profile/PetCharacteristics'
import PetInfo from './components/pet-profile/PetInfo'
import PetPlanOverview from './components/pet-profile/PetPlanOverview'

export const DEBUG = process.env.DEBUG === 'true'

export const DEFAULT_REQUEST_HEADERS = {
	'Content-Type': 'application/json'
}

export const LOGO_IMAGE =
	'https://static.wixstatic.com/media/1b43b4_9ba89969bcb54b6a8830e9b580f9a025~mv2.jpg'

export const apiHost = process.env.REACT_APP_API_HOST
export const graphqlHost = `${apiHost}/graphql`
export const mediaHost = process.env.REACT_APP_MEDIA_HOST
export const mediaPath = mediaHost
export const appId = process.env.REACT_APP_APP_ID

export const routePrefix = process.env.REACT_APP_BASE_PATH || ''

export const navIcons: any = {
	Settings,
	LocationCity,
	Payments,
	DateRange,
	Receipt,
	Pets,
	Dashboard
}

export const settingsIcons: Record<string, any> = {
	'truck-delivery': TruckDelivery,
	invoice: Invoice,
	'credit-card': CreditCard,
	send: Send,
	password: Password,
	'eye-password-show': EyePasswordShow
}

export const petProfileTabs = [
	{
		label: 'Info',
		linkTo: '',
		key: 'info',
		component: PetInfo,
		enabled: true
	},
	{
		label: 'Characteristics',
		linkTo: 'characteristics',
		key: 'characteristics',
		component: PetCharacteristics,
		enabled: true
	},
	{
		label: 'Plan',
		linkTo: 'plan',
		key: 'plan',
		component: PetPlanOverview,
		enabled: true
	}
]

export const profileColors = [
	red[500],
	lightBlue[500],
	lime[500],
	purple[500],
	amber[500],
	pink[500],
	deepPurple[500],
	indigo[500],
	blue[500],
	cyan[500],
	teal[500],
	green[500],
	lightGreen[500],
	yellow[500],
	orange[500],
	deepOrange[500],
	brown[500]
]

export const noImage = [
	'https://static.wixstatic.com/media/1b43b4_af8051f1dd0a4cdc81cd4418a9b9cd73~mv2.png',
	'https://static.wixstatic.com/media/1b43b4_e1842d368ca14f469bd4d5022dae15bc~mv2.png',
	'https://static.wixstatic.com/media/1b43b4_f6f976945fb24f3a8971b3a264b2402b~mv2.png'
]

export const paymentBrandIcons: { [name: string]: string } = {
	discover: 'https://static.wixstatic.com/media/1b43b4_4f2658744ef74f89ad4d73d4b3a2275a~mv2.png',
	'american-express':
		'https://static.wixstatic.com/media/1b43b4_561a685a69a94d21a4601f10d59e5ec9~mv2.png',
	mastercard: 'https://static.wixstatic.com/media/1b43b4_60475900ea854cfeb8aff41e2d890b55~mv2.png',
	visa: 'https://static.wixstatic.com/media/1b43b4_80334d85ddfa47c28957696915d50a28~mv2.png'
}
